// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__ApScI","DesktopOnly":"Toolbar_DesktopOnly__LuPaL"};